// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../primitives/Json.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TriggerDownload from "../primitives/TriggerDownload.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function decodeAndMakeUrl(json) {
  return Stdlib_Option.map(Stdlib_Option.orElse(Json.flatDecodeDictFieldString(Json.decodeDict(json), "url"), Json.flatDecodeDictFieldString(Json.flatDecodeDictField(Json.decodeDict(json), "file", Json.decodeDict), "url")), prim => new URL(prim));
}

function use(request, triggerDownloadOpt, param) {
  let triggerDownload = triggerDownloadOpt !== undefined ? triggerDownloadOpt : url => TriggerDownload.fromUrl(undefined, url);
  let match = React.useState(() => "NotAsked");
  let setRequestResult = match[1];
  let requestAndDownload = React.useCallback(() => {
    setRequestResult(param => "Loading");
    Future.tapError(Future.tapOk(request(), jsonResult => {
      let fileUrl = decodeAndMakeUrl(jsonResult);
      if (fileUrl !== undefined) {
        Future.get(triggerDownload(Primitive_option.valFromOption(fileUrl)), result => {
          if (result.TAG === "Ok") {
            return setRequestResult(param => ({
              TAG: "Done",
              _0: {
                TAG: "Ok",
                _0: undefined
              }
            }));
          } else {
            return setRequestResult(param => ({
              TAG: "Done",
              _0: {
                TAG: "Error",
                _0: "LinkingOpenUrlError"
              }
            }));
          }
        });
        return;
      } else {
        return setRequestResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: "MissingFileUrl"
          }
        }));
      }
    }), error => setRequestResult(param => ({
      TAG: "Done",
      _0: {
        TAG: "Error",
        _0: {
          TAG: "RequestError",
          _0: error
        }
      }
    })));
  }, [request]);
  return [
    match[0],
    requestAndDownload
  ];
}

export {
  use,
}
/* react Not a pure module */
